import React, { Suspense } from 'react';
import { Element } from 'react-scroll';
import { CSSReset, Spinner, Center } from '@chakra-ui/react';


const Header = React.lazy(() => import('../Components/Home/header'));
const ServicesOverview = React.lazy(() => import('../Components/Home/ServicesOverview'));
const WhySection = React.lazy(() => import('../Components/Home/WhySection'));
const FleetSnapshot = React.lazy(() => import('../Components/Home/FleetSnapshot'));
const ContactTeaser = React.lazy(() => import('../Components/Home/ContactTeaser'));
const PartnersCarousel = React.lazy(() => import('../Components/Home/PartnersCarousel'));
const FleetCarousel = React.lazy(() => import('../Components/Home/FleetCarousel'));
const ScrollToTopButton = React.lazy(() => import('../Components/ScrollToTopButton'))

const Home = () => {
  return (
    <>
      <CSSReset />
      <Suspense fallback={
        <Center height="100vh">
          <Spinner
            thickness="4px"
            speed="0.65s"
            emptyColor="gray.200"
            color="#ec562c"
            size="xl"
          />
        </Center>
      }>
         <Header />
         <FleetSnapshot />
         <PartnersCarousel />
         <FleetCarousel />
         <ServicesOverview />
         <WhySection />
         <ContactTeaser />
         <ScrollToTopButton />
      </Suspense>
    </>
  );
};

export default Home;
